import { gql } from "@apollo/client";
import WagerTypesFragments from "./WagerTypesFragment";
import TimeAndStatusFragments from "./TimeAndStatusFragment";
import RaceDetailsFragments from "./RaceDetailsFragment";
import ResultsFragments from "./ResultsFragment";
import PromosFragments from "./PromosFragment";
import BettingInterestsFragments from "./BettingInterestsFragment";
import RaceTrackFragments from "./RaceTrackFragment";
import ProbablesFragment from "./ProbablesFragment";

const RaceFragment = {
  entry: gql`
    fragment Race on Race {
      id
      tvgRaceId
      ...RaceTrack
      ...RaceDetails
      ...TimeAndStatus
      ...WagerTypes
      ...Promos
      ...Results
      ...BettingInterests
      ...Probables
    }
    ${RaceTrackFragments.entry}
    ${WagerTypesFragments.entry}
    ${TimeAndStatusFragments.entry}
    ${RaceDetailsFragments.entry}
    ${BettingInterestsFragments.entry}
    ${ResultsFragments.entry}
    ${PromosFragments.entry}
    ${ProbablesFragment.entry}
  `
};

export default RaceFragment;
